import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config.js";
import { CollapseTransition } from "@ivanv/vue-collapse-transition";
import gsap from "gsap";

export default {
  props: ["mySpace"],
  components: {
    CollapseTransition,
  },
  data() {
    return {
      id: this.$options.name,
      company: this.$store.state.company,
      user: this.$store.state.user,
      tree: null,
      spaceBtnStatus: false,
      folderBtnStatus: false,
    };
  },

  created() {
    this.getTree();

    EventBus.$on(`${this.id}-reset`, () => {
      this.getTree();
    });

    EventBus.$on(`right-sidebar-show`, (data) => {
      if (data.id === "space") {
        this.spaceBtnStatus = true;
      }

      if (data.id === "newFolder") {
        this.folderBtnStatus = true;
      }
    });

    EventBus.$on(`closeallactions`, () => {
      this.spaceBtnStatus = false;
      this.folderBtnStatus = false;
    });
  },
  methods: {
    openFolder(item) {
      item.expanded = true;

      this.$router.push(
        `/${this.company}/${this.mySpace ? "myspace" : "home"}/expanded/${
          item.id
        }`
      );
    },
    handleToggleExpand(e, key) {
      e.preventDefault();

      this.toggleChild(key);
    },
    toggleChild(key) {
      const newChild = this.tree[key];

      newChild.expanded = !newChild.expanded;

      //close all children if present
      if (newChild.nodes) {
        newChild.nodes = newChild.nodes.map((node) => {
          return { ...node, expanded: false };
        });
      }

      this.tree[key] = newChild;
    },
    getTree() {
      this.loaded = false;

      if (this.$route.params.id != null) {
        let id = this.$route.params.id;
        this.$axios
          .get(
            baseUrl +
              "/folders?expanded=" +
              this.$route.params.id +
              "&myspace=" +
              this.mySpace,
            {
              responseType: "json",
            }
          )
          .then((response) => {
            this.tree = this.buildTree(response.data);

            this.loaded = true;
          });
      } else {
        this.$axios
          .get(baseUrl + "/folders" + "?myspace=" + this.mySpace, {
            responseType: "json",
          })
          .then((response) => {
            this.tree = this.buildTree(response.data);

            this.loaded = true;
          });
      }
    },

    buildTree(data) {
      return data.map((node) => {
        node.nodes = this.buildNodes(node.nodes);

        return node;
      });
    },
    buildNodes(nodes) {
      if (nodes && nodes.length) {
        //has nodes that need editing
        return nodes.map((node) => {
          if (node.nodes && nodes.length) {
            node.nodes = this.buildNodes(node.nodes);
          } else {
            node.nodes = [];
          }

          node.editFolderName = false;

          return node;
        });
      } else {
        //no nodes add blank
        return [];
      }
    },
    addSpace() {
      if (this.spaceBtnStatus) {
        //close actions
        EventBus.$emit(`closeallactions`);
      } else {
        EventBus.$emit(`right-sidebar-show`, {
          id: "space",
          data: {},
        });
      }
    },
    addFolder() {
      if (this.folderBtnStatus) {
        //close actions
        EventBus.$emit(`closeallactions`);
      } else {
        EventBus.$emit(`right-sidebar-show`, {
          id: "newFolder",
          data: {
            folderId: "",
            mySpace: 1,
          },
        });
      }
    },

    onEnter(el, done) {
      gsap.from(el, {
        opacity: 0,
        x: -10,
        delay: el.dataset.index * 0.05,
        onComplete: done,
      });
    },
    onLeave(el, done) {
      gsap.to(el, {
        opacity: 0,
        x: 0,
        delay: el.dataset.index * 0.05,
        onComplete: done,
      });
    },
  },
  watch: {
    $route() {
      if (!this.tree) {
        this.getTree();
      }
    },
    mySpace() {
      this.getTree();
    },
  },
};
